import mock from '../../MockConfig';
import userManagementList from '../../db/userManagementList';

mock.onGet('/api/userManagement/users').reply(200, userManagementList);
